<template>
  <div class="w-full flex flex-col bg-white z-10" v-if="user">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      dashboardPath: 'auth/dashboardPath',
    }),
  },
};
</script>

<style lang="scss" scoped>
  svg:hover {
    fill: forestgreen;
  }
</style>
